<template>
  <alzata-odata-table
    ref="grid"
    clickable
    title="Administrators"
    endpoint="/api/v1/profiles"
    :columns="[
      {
        id: 'DisplayName',
        label: 'Name',
        sortable: true,
      },
      {
        id: 'Email',
        label: 'Email',
        sortable: true,
      },
      {
        id: 'LastLogin',
        label: 'Last Login',
        sortable: true,
        formatter: (x) => {
          return formatDateFull(x.lastLogin);
        },
      },
    ]"
    :actions="[
      {
        id: 'edit',
        icon: (item) => 'far/pencil',
        tooltip: 'Edit',
        default: true,
        click: show,
      },
      {
        id: 'deleteAdministrator',
        icon: (item) => 'far/trash',
        tooltip: 'Delete',
        default: true,
        click: showDeleteAdministrator,
      },
    ]"
    :filters="['IsAdmin eq true']"
  >
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-primary btn-sm ms-1"
        @click="show({})"
      >
        <alzata-icon icon="far/plus-circle" /> Add an Admin
      </button>
    </template>
  </alzata-odata-table>
  <edit-admin-dialog ref="editDialog" @save="save" />
  <delete-administrator-dialog ref="deleteAdministratorDialog" @deleteAdministrator="deleteAdministrator"/>
</template>

<script>
import EditAdminDialog from "@/dialogs/EditAdminDialog.vue";
import { DateTime } from "luxon";
import { settings } from "../apis/baseApiClient";
import DeleteAdministratorDialog from "@/dialogs/DeleteAdministratorDialog.vue";

console.log("Settings", settings);

export default {
  name: "AdminList",
  components: {
    EditAdminDialog,
    DeleteAdministratorDialog
  },
  computed: {
    console: () => console,
  },
  methods: {
    formatDateFull(dateString) {
      this.console.log(dateString);
      if (!dateString) {
        return "Never";
      }
      const dateValue = DateTime.fromISO(dateString, { zone: "utc" });
      const localDateTime = dateValue
        .toLocal()
        .toLocaleString(DateTime.DATETIME_MED);
      const relative = dateValue.toLocal().toRelative();

      return `${localDateTime} (${relative})`;
    },
    show(admin) {
      this.$refs.editDialog.show(admin);
    },
    async save(admin) {
      const body = {
        firstName: admin.firstName,
        lastName: admin.lastName,
        email: admin.email,
        phoneNumber: admin.phoneNumber,
        password: admin.password,
        isVeteran: false,
        isAdmin: true,
      };

      this.console.log("Saving admin", body);

      if (admin.userId) {
        const res = await this.apiClient.putJson(
          `/api/v1/profiles/${admin.userId}`,
          {
            body,
          }
        );

        if (!res.success) {
          alert("error saving admin");
          return;
        }
      } else {
        const res = await this.apiClient.postJson(
          "/api/v1/profiles/create-administrator",
          {
            body,
          }
        );
        if (!res.success) {
          alert("error saving admin");
          return;
        }
      }

      this.$refs.grid.reload();
      this.$refs.editDialog.hideEditAdmin();
    },
    showDeleteAdministrator(administrator) {
      this.$refs.deleteAdministratorDialog.show(administrator);
    },
    async deleteAdministrator(administrator) {
      await this.apiClient.doDelete(`/api/v1/profiles/delete-administrator/${administrator.userId}`, { });
      this.$refs.deleteAdministratorDialog.hide();
      this.$refs.grid.reload();
    },
  },
};
</script>
